import React from 'react'
import Image from 'next/image'
import styled from 'styled-components'

const Container = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  padding: 1rem;
  z-index: ${({ theme }) => theme.zindex.overlay};
  background-color: white;
  border-radius: 6px 6px 0 0;
  -webkit-box-shadow: ${({ theme }) => theme.defaultBoxShadow};
  -moz-box-shadow: ${({ theme }) => theme.defaultBoxShadow};
  box-shadow: ${({ theme }) => theme.defaultBoxShadow};

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
  }
  p {
    white-space: pre-line;
  }

  .close-button {
    background-color: transparent;
    border: none;
    float: right;
  }

  @media (min-width: 769px) {
    max-width: 500px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 6px 6px 0 0;
    -webkit-box-shadow: ${({ theme }) => theme.defaultBoxShadow};
    -moz-box-shadow: ${({ theme }) => theme.defaultBoxShadow};
    box-shadow: ${({ theme }) => theme.defaultBoxShadow};
  }
`

const InfoArea = ({ isOpen, handleClose, children }) =>
  isOpen && (
    <Container>
      <button title='Sluitknop' className='close-button' onClick={handleClose}>
        <Image src='/assets/icons/no-check.svg' width={16} height={16} alt='Icoon van kruis' />
      </button>
      {children}
    </Container>
  )

export default InfoArea
